import { ReactNode, useId } from "react";

type ResponsiveTableRegionProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

function ResponsiveTableRegion({ label, children, className = "" }: ResponsiveTableRegionProps) {
  const instructionsId = useId();
  const classes = ["responsive-table-region", className].filter(Boolean).join(" ");

  return (
    <div
      className={classes}
      role="region"
      aria-label={label}
      aria-describedby={instructionsId}
      tabIndex={0}
    >
      <span id={instructionsId} className="visually-hidden">
        This table can be scrolled horizontally when needed.
      </span>
      {children}
    </div>
  );
}

export default ResponsiveTableRegion;
